
window['eventCurrent'] = {};
const updatesse = function(data_name, data_value, callback){
	if ( typeof EventSource == 'undefined' ) { return false; }
	
	if ( window['eventCurrent'] && window['eventCurrent'][data_name] )
		{
			window['eventCurrent'][data_name].close();
			window['eventCurrent'][data_name] = false;
		}
	
	if ( typeof data_value == 'object' ) { data_value = data_value.join(','); }
	
	var events = new EventSource(process.env.REACT_APP_API_URL+'/api/v1/updatesse/events?observeData=' + data_name + '&valueName=' + data_value);
	events.onmessage = (event) => {
		
			if ( event.data == 'update' )
				{
					callback();
				}
			else if ( event.data !== 'first load' && event.data !== 'keep-alive' )
				{
					try { callback(event.data); }
					catch(err){  }
				}
		};
	
	window['eventCurrent'][data_name] = events;
}

export { updatesse };